import dataLoader from './Data/DataLoader/index';

export {
    dataLoader
};
